import styled from 'styled-components';

export const StyledImage= styled.img`
    width: 100%;
`;
export const StyledPicture= styled.picture`
    img {
        width: 100%;
    }
`;